import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { AUTH_TYPE, AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';

export const cache: InMemoryCache = new InMemoryCache();

export const createApolloLink = (getToken: () => Promise<string>) => {
  const url = process.env.REACT_APP_XENIA_API_URL as string;
  const region = process.env.REACT_APP_AWS_REGION as string;

  const auth: AuthOptions = {
    type: AUTH_TYPE.AWS_LAMBDA,
    token: getToken
  };

  const httpLink = new HttpLink({ uri: url });
  const authLink = createAuthLink({ url, region, auth });
  const subscriptionLink = createSubscriptionHandshakeLink({ url: url, region, auth }, authLink);

  return authLink.concat(subscriptionLink).concat(httpLink);
};

let apolloClientInstance: ApolloClient<any> | null = null;

const getApolloClient = (getToken: () => Promise<string>) => {
  if (!apolloClientInstance) {
    apolloClientInstance = new ApolloClient({
      link: createApolloLink(getToken),
      cache,
      defaultOptions: {
        watchQuery: { fetchPolicy: 'cache-and-network' },
        query: { fetchPolicy: 'network-only' }
      }
    });
  }

  return apolloClientInstance;
};

export default getApolloClient;
